import styled from '@emotion/styled';
import { Box } from '@lightspeed/flame/Core';
import { Text } from '@lightspeed/flame/Text';

export const StyledCountdownCalendar = styled(Box)`
  position: relative;
  width: 148px;
  height: 169px;
`;

export const CalendarBody = styled(Box)`
  position: absolute;
  width: 148px;
  height: 130px;
  top: 34px;
  left: 0;
  background: #ffffff;
  box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.1);
  border-radius: 0 0 6px 6px;
`;

export const CalendarHeader = styled(Box)`
  position: absolute;
  width: 148px;
  height: 34px;
  top: 0;
  left: 0;
  background: #e81c1c;
  border-radius: 6px 6px 0 0;
`;

export const RingHole = styled(Box)`
  position: absolute;
  width: 10px;
  height: 19px;
  top: 0;
`;

export const RingHoleWhite = styled(Box)`
  position: absolute;
  width: 10px;
  height: 10px;
  top: 5px;
  left: 0;
  background: #ffffff;
  border-radius: 50%;
`;

export const RingHoleBlack = styled(Box)`
  position: absolute;
  width: 8px;
  height: 19px;
  top: -6px;
  left: 1px;
  background: #545454;
  border-radius: 20px;
`;

export const CountdownNumber = styled(Text)`
  position: absolute;
  width: 104px;
  height: 97px;
  top: 33px;
  left: 21px;
  font-family: Lato, sans-serif;
  font-weight: 700;
  font-size: 80.7px;
  line-height: 97px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #000000 !important;
  margin: 0 !important;
`;

export const DaysLeftText = styled(Text)`
  position: absolute;
  width: 97px;
  height: 29px;
  top: 118px;
  left: 27px;
  font-family: Lato, sans-serif;
  font-weight: 700;
  font-size: 21.3px;
  line-height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #000000 !important;
  margin: 0 !important;
`;
